













import Vue from 'vue';
import StarIcon from '@components/svg/star-rating-icon.vue';
import StarHalfFullIcon from '@components/svg/star-half-rating-icon.vue';

enum StarType {
  full = 'f',
  half = 'h',
  empty = 'e',
}

export default Vue.extend({
  components: {
    StarIcon,
    StarHalfFullIcon,
  },
  name: 'StarRating',
  props: {
    rating: Number,
    showRating: Boolean,
  },
  computed: {
    roundedRating(): number {
      return Math.round(this.rating * 10) / 10;
    },
    starsArray(): string[] {
      const stars: string[] = [];

      for (let i = 0; i < 5; i++) {
        if (this.rating >= i + 0.9) {
          stars.push(StarType.full);
        } else if (this.rating <= i + 0.2) {
          stars.push(StarType.empty);
        } else {
          stars.push(StarType.half);
        }
      }

      return stars;
    },
  },
  data() {
    return {
      StarType,
    };
  },
});
